import React from "react";
import { Button, ButtonProps } from "antd";
import { cn  } from "../../../lib/utils";

interface ButtonWrapperProps extends ButtonProps {
  children: React.ReactNode;
  className?: string;
}

const ButtonWrapper: React.FC<ButtonWrapperProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <Button {...props} className={cn(" !py-4 sm:!py-5 !px-6 sm:!px-8",className)}>
      {children}
    </Button>
  );
};

export default ButtonWrapper;
